/*******************************************************************************
 *                                                                             *
 * WARNING! This file was automatically generated from the server-side model!  *
 * You shouldn't edit this by hand.  If you want to modify the client-side     *
 * model behavior, you should modify: ../ModelCustomerFuelOptions.ts           *
 *                                                                             *
/*******************************************************************************/

import { Endpoint, ModelRow, RowConstructor } from "@mcleod/core";

const endpointPath = "lme/ar/customer-fuel-options";

export class AutogenModelCustomerFuelOptions<RowType extends ModelRow> extends Endpoint<RowType, RowCustomerFuelOptionsFields> {
	constructor(ctor: RowConstructor) {
		super(endpointPath, ctor);
	}
}

export class AutogenRowCustomerFuelOptions extends ModelRow<RowCustomerFuelOptionsFields> {
	constructor(values?: Partial<RowCustomerFuelOptionsFields>) {
		super(endpointPath, true, values);
	}
}

export interface RowCustomerFuelOptionsFields {
	amount: number;
	apply_doe_rate: string;
	base_price: number;
	"charge_code.acct_int_id": string;
	"charge_code.acct_int_name": string;
	"charge_code.amount": number;
	"charge_code.charge_rate_method": string;
	"charge_code.co_amount": number;
	"charge_code.co_deduct_code_id": string;
	"charge_code.co_pay_method": string;
	"charge_code.co_payee_acct": string;
	"charge_code.co_percent": number;
	"charge_code.company_id": string;
	"charge_code.descr": string;
	"charge_code.edi_code": string;
	"charge_code.exclude_commissions": string;
	"charge_code.glid": string;
	"charge_code.id": string;
	"charge_code.incl_in_freight": string;
	"charge_code.is_fuel_surcharge": string;
	"charge_code.is_intermodal": string;
	"charge_code.is_taxable": string;
	"charge_code.is_tonu": string;
	"charge_code.ltl_allocation_method": string;
	"charge_code.oo_amount": number;
	"charge_code.oo_deduct_code_id": string;
	"charge_code.oo_pay_method": string;
	"charge_code.oo_payee_acct": string;
	"charge_code.oo_percent": number;
	"charge_code.pay_company_hourly_driver": string;
	"charge_code.prev_flag": string;
	"charge_code.rate": number;
	"charge_code.wf_min_charge": number;
	"charge_code.wf_occ_doctype": string;
	"charge_code.wf_occ_queue": string;
	"charge_code.who_to_pay": string;
	company_id: string;
	credit: string;
	custom_calc: string;
	custom_fsc_hdr_id: string;
	custom_fsc_index_id: string;
	custom_fsc_region_id: string;
	customer_id: string;
	date_opt: string;
	deduct_code_id: string;
	delay_days: number;
	descr: string;
	fsc_cycle_code: string;
	fuel_percent: number;
	fuel_surcharge_id: string;
	fuel_surcharge_pay_id: string;
	fuel_variance: number;
	id: string;
	ltl_code: string;
	ltl_descr: string;
	method: string;
	"order_type.company_id": string;
	"order_type.descr": string;
	"order_type.id": string;
	"order_type.is_active": string;
	"order_type.order_mode": string;
	"order_type.planning_color": number;
	order_type_id: string;
	region: string;
	round_surchg_calc: string;
	surcharge_type: string;
	surchg_enddt: Date;
	surchg_strtdt: Date;
	truckload_ltl: string;
	weight_type: string;
	custom_fsc_hdr_id: string;
	custom_fsc_index_id: string;
	fsc_cycle_code: string;
}

